import { useCallback } from "react";
import ReactGA from "react-ga4";

export const useTrackEvent = () => {
  return useCallback((eventName, params = {}) => {
    ReactGA.event(eventName, params);
  }, []);
};
